import { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import TickerBar from '../components/TickerBar';
import Marquee from '../components/Marquee';
import Colourways from '../components/Colourways';
import Story from '../components/Story';
import Details from '../components/Details';
import Quote from '../components/Quote';
import Lookbook from '../components/Lookbook';
import LifestyleBanner from '../components/LifestyleBanner';
import Footer from '../components/Footer';
import { NotifyProvider } from '../components/Notify';

export default function Landing() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll('.reveal'));
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <NotifyProvider>
      <TickerBar />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Colourways />
        <Story />
        <LifestyleBanner />
        <Details />
        <Quote />
        <Lookbook />
      </main>
      <Footer />
    </NotifyProvider>
  );
}
